import { VertiType } from "./VertiType.js";
import { TenantId } from "./Tenant.js";
import { VertiNodeTenantId } from "./VertiNodeTenant.js";
import type { vertiTypeTenantIds } from "./vertiTypeTenantIds.js";

export const vertiTypeTargetFromSourceTenantIdMappings: {
	[TargetVertiType in VertiType]: {
		[SourceVertiType in Exclude<VertiType, TargetVertiType>]: Record<
			(typeof vertiTypeTenantIds)[SourceVertiType][number],
			(typeof vertiTypeTenantIds)[TargetVertiType][number]
		>;
	};
} = {
	[VertiType.Flex]: {
		[VertiType.Node]: {
			[VertiNodeTenantId.cz]: TenantId.cz,
			[VertiNodeTenantId.eu]: TenantId.eu,
		},
	},
	[VertiType.Node]: {
		[VertiType.Flex]: {
			[TenantId.cz]: VertiNodeTenantId.cz,
			[TenantId.sk]: VertiNodeTenantId.cz,
			[TenantId.eu]: VertiNodeTenantId.eu,
			[TenantId.pl]: VertiNodeTenantId.eu,
		},
	},
};
